import { DataModel } from "common/models/utility-models/base-model";

export class StudentAssignmentOverviewModel extends DataModel {
  assignment_id:any=''
    topic: any = '';
    type: any = '';
    location: any = '';
    category_name: any = '';
    trainer_name: any = '';
    assignment_email: any = '';
    student_file_submit_date: any = '';
    start_date: any = '';
    end_date: any = '';
    display_filename: any = '';
    created: any = '';
    feedback_flag: any = '';
    student_feedback: any = '';
    description: any = '';
    assignment_uploaded_documents: any = '';
    student_file_submit: any = '';
    trainer_feedback_to_student_date: any = '';
    trainer_feedback_to_student: any = '';
    student_ratings_date: any = '';
    student_ratings: any = '';
    file_url_path: any = '';
    docPathUrl: any = '';
    document_path: any = '';
    docPath: any ='';
    student_doc_url_path:any='';
    docAssignmetDownload:any='';

  }